import React, { useState, useEffect } from 'react';
import { getServices } from '../../../../api/services/servicesApi';

import HomeServiceCard from '../../cards/HomeServiceCard/HomeServiceCard';

import './HomeServices.css';

const HomeServices = () => {
  const [services, setServices] = useState([]);

  //Service Home Page
  const getAllServices = async () => {
    const allServices = await getServices();
    setServices(allServices);
  };

  useEffect(() => {
    getAllServices();
  }, []);

  return (
    <div className='home-services-container'>
      <h1>OUR SERVICES</h1>
      <div className='images-container'>
        {services.map(
          (service, i) =>
            service.showOnHome && (
              <HomeServiceCard
                key={i}
                src={service.homeImageUrl || service.imageUrl}
                descTitle={service.homeTitle || service.title}
                leftDesc={service.homeDescription}
                link={service.homeJaneUrl || service.janeUrl}
                title={service.homeLabel || service.title}
              />
            ),
        )}
      </div>
    </div>
  );
};

export default HomeServices;
